import { Avatar as AvatarPrimitive } from "@base-ui/react/avatar";

import { cn } from "@lib/utils";

/** An image element with a fallback for representing the user.
 * @prop className - The class name to apply to the avatar.
 * @prop size - The size of the avatar.
 */
const Avatar = ({
	className,
	size = "default",
	...props
}: AvatarPrimitive.Root.Props & {
	size?: "default" | "sm" | "lg" | "md";
}) => (
	<AvatarPrimitive.Root
		data-slot="avatar"
		data-size={size}
		className={cn(
			`after:border-border group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute
			after:inset-0 after:rounded-full after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6
			dark:after:mix-blend-lighten`,
			className,
		)}
		{...props}
	/>
);

const AvatarImage = ({ className, ...props }: AvatarPrimitive.Image.Props) => (
	<AvatarPrimitive.Image
		data-slot="avatar-image"
		className={cn("aspect-square size-full rounded-full object-cover", className)}
		{...props}
	/>
);

const AvatarFallback = ({ className, ...props }: AvatarPrimitive.Fallback.Props) => (
	<AvatarPrimitive.Fallback
		data-slot="avatar-fallback"
		className={cn(
			`text-muted-foreground flex size-full items-center justify-center rounded-full bg-white text-sm opacity-40
			group-data-[size=sm]/avatar:text-xs`,
			className,
		)}
		{...props}
	/>
);

Avatar.displayName = "Avatar";
AvatarImage.displayName = "AvatarImage";
AvatarFallback.displayName = "AvatarFallback";

export { Avatar, AvatarImage, AvatarFallback };
